// extracted by mini-css-extract-plugin
export default {"poiPoint":"POIPoints_poiPoint__IKUTq","key":"POIPoints_key__JmxzB"};